import { motion } from 'framer-motion';

import Mainwrapper from '../wrapper/Mainwrapper';
import {
  TopProductSection,
  BestReviewSection,
  BrandStorySection,
} from '../components/section/main';
import MoblieTopProduct from '../components/section/main/MobileTopProduct';
import Meta from '../../components/seo/Meta';
import { SITE_URL } from '../../constants/seo';
import FlutingButton from '../components/ui/FlutingButton';
import { BannerSlider } from '../components/section/main/BannerSlider';
import InstagramButton from '../components/ui/InstagramButton';

export default function Main() {
  return (
    <>
      <Meta
        title='몽솜 | 사소한 순간까지 당신 곁에'
        description='답례품·대량구매 전문 쇼핑몰 몽솜. 상황별 맞춤 선물, 빠른 상담.'
        canonical={`${SITE_URL}/`}
      />
      <Mainwrapper>
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 2, ease: [0.25, 0.46, 0.45, 0.94] }}
          className='w-full'
        >
          {/* <HeroSection /> */}
          <BannerSlider />
          <TopProductSection />
          <MoblieTopProduct />
          <BestReviewSection />
          <BrandStorySection />
          <InstagramButton />
          <FlutingButton />
          {/* <ChatFlutingButton /> */}
        </motion.div>
      </Mainwrapper>
    </>
  );
}
